import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=11232e5c&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=11232e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11232e5c",
  null
  
)

export default component.exports